import React from 'react';

const Rond = ({couleur = "#F8D541"}) => {
    return (
        <svg className={"iconeAPlanifier"} width="18" height="18" viewBox="0 0 18 18" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <circle cx="9" cy="9" r="9" fill={couleur}/>
        </svg>
    );
};

export default Rond;
